import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../ngrx';

export const authUserRegistrationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  if (authStore.isUserRegistrationAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['auth/sign-in']);
};
